import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useMemo } from "react";
import { PickupLocationContext } from "./dashboard/store/PickupLocationContext";

type CsaPickupLocationFormElementProps = {
  onLocationSelected: (pickupLocationId: string) => void;
  selectedLocationId: string;
};

const CsaPickupLocationFormElement = ({
  onLocationSelected,
  selectedLocationId,
}: CsaPickupLocationFormElementProps) => {
  const { pickupLocations } = useContext(PickupLocationContext);
  const pickupLocationCards = useMemo(() => {
    return pickupLocations.map((loc) => {
      const mapsLink = `https://www.google.com/maps/dir/?api=1&destination=${loc.latitude},${loc.longitude}`;
      const pickupDays = loc.days.map((day) => {
        return (
          <li key={loc._id + day.day} className="capitalized">
            {day.day}s {day.startTime} - {day.endTime}
          </li>
        );
      });
      return (
        <div
          key={loc._id}
          onClick={() => onLocationSelected(loc._id)}
          className={
            selectedLocationId === loc._id
              ? "csa-selected info-card info-card-clickable csa-pickup-detail-box"
              : "info-card info-card-clickable csa-pickup-detail-box"
          }
        >
          <div className="csa-pickup-details-item">
            <h4>{loc.name}</h4>
            <ul>{pickupDays}</ul>
          </div>
          <a
            href={mapsLink}
            target="_blank"
            key={loc._id}
            className="csa-location-link"
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faLocationDot} />
            See on map
          </a>
        </div>
      );
    });
  }, [onLocationSelected, pickupLocations, selectedLocationId]);
  return <>{pickupLocationCards}</>;
};

export default CsaPickupLocationFormElement;
